<template>
  <div width="100%">
    <s-loading v-if="loading"/>

    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01 th_gray v-data-table">
        <thead>
          <tr>
            <th v-for="(item,index) in headers" :key=index :width="item.width" :class="[headerThClass]">
              {{ item.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item,index) in items">
            <slot name="item" v-bind="{item, index}">
              <tr :key=index @click="$emit('input', item)" >
                <td v-for="(head,index) in headers" :key=index>
                  {{ item[head.value] }}
                </td>
              </tr>
            </slot>
          </template>

          <slot name="body.append"/>

        </tbody>
      </table>
     </div> <!--// scroll_wrap -->

    <slot name="footer"/>

  </div>
</template>

<style>
table.v-data-table td { height: 40px; }

.s-tbl-footer-wrap  { text-align: center; margin: 0px; padding: 5px 5px 3px 5px;}
.s-tbl-footer-left  { height: 25px; line-height: 25px; margin-top: 2px; float: left;   text-align: left; color: #6E6E6E; }
.s-tbl-footer-right { height: 25px; line-height: 25px; margin-top: 1px; float: right;  padding-right: 3px; color: #6E6E6E; }
/* .s-tbl-footer-center{ text-align:center;  margin:0 auto !important; display:inline-block; width: 500px; position: relative !important;  cursor: auto; user-select: text; line-height: 18px;} */
.s-tbl-footer-center{  display:inline-block; line-height: 20px;}

/* .imd-sm-table tfoot tr { height: 30px !important; } */
/* 디버깅용 */
/* .s-tbl-footer-wrap  { border: 1px solid blue; }
.s-tbl-footer-left, .s-tbl-footer-right, .s-tbl-footer-center{ border: 1px solid red; } */

</style>

<script>
const isDebug = false
export default {
  props : {
    loading: {type: Boolean, default: false},
    items: { type: Array, },
    headers: { type: Array, },
    page: { type: Number, }, // 페이징
    itemsPerPage : { type: Number, }, // 페이징
    options: { Type: Object, },
    headerThClass: {},
  },
  created() {
    this.emitOptions() // 호환성 문제로 처음에 무조건 호출
  },
  watch: {
    // loading(n,p) {
    //     if (n) {
    //       this.$Progress.start()
    //     } else {
    //       this.$Progress.finish()
    //     }
    // },
    page: 'emitOptions',
    // itemsPerPage: 'emitOptions',
    items() {
      isDebug && console.log("[v-data-table] watch items :", this.items);
    },
  },
  methods: {
    emitOptions() {
      let newOptions = {
        ...this.options,
        page: this.page,
        // itemsPerPage: this.itemsPerPage,
        }
      this.$emit("update:options", newOptions );
    }
  },
}
</script>